/* ==========================================================================
   ModalRxjs > Template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');

const { addStyle, addData, prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');

const ButtonTemplate = require('../button-rxjs/template');

const configuration = require('./client/js/config');

/* Close render */
const closeRender = context =>
    ButtonTemplate(
        addStyle(
            addData(
                {
                    icon: configuration().icon.cancel
                },
                {
                    type: configuration().type.close
                }
            ),
            [configuration().css.close]
        ),
        context
    );

/**
 * ModalRxjs template
 * @param {object} data Object containing the data model for this component.
 * @param {object} context The general context object.
 * @returns {object} Additional data to have available in the template
 */
module.exports = function Template(data, context) {
    /* Data */
    const { config = {}, title = '', body = '', footer = '' } = data;
    const { styles = [], hasClose = true } = config;
    const { dataType } = prepareDataConfig(config.data);

    /* Template */
    return html(`
        <div class='${['modal-rxjs', ...styles].join(' ').trim('')}'
            data-component='${configuration().component}'
            ${dataType ? `data-type='${dataType}'` : ''}
            data-config='${JSON.stringify({
                ...config,
                hasClose
            })}'>
            <div class='modal-rxjs__wrapper' data-modal-wrapper=''>
                ${hasClose ? closeRender(context) : ''}
                ${title ? `<div class='modal-rxjs__header'><p class='modal-rxjs__title'>${title}</p></div>` : ''}
                <div class='modal-rxjs__body'>${body}</div>
                ${footer ? `<div class='modal-rxjs__footer'>${footer}</div>` : ''}
            </div>
        </div>
    `);
};
